import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get duplicates cargo names
 * */
function* getCargoDuplicates() {
    const response = yield call(api.getCargoDuplicates);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_CARGO_DUPLICATES.SUCCESS,
            data: response.data,
        });
        return;
    }

    yield put({
        type: actionTypes.GET_CARGO_DUPLICATES.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetCargoDuplicates() {
    while (true) {
        yield take(actionTypes.GET_CARGO_DUPLICATES.REQUEST);
        yield fork(getCargoDuplicates);
    }
}

/**
 * Delete cargo by id
 * */
function* deleteCargoDuplicate(item) {
    const response = yield call(api.deleteCargoDuplicate, item);
    if (response.status === 200) {
        yield put({
            type: actionTypes.DELETE_CARGO_DUPLICATE.SUCCESS,
            item,
        });
        // todo message in response.
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.DELETE_CARGO_DUPLICATE.FAILURE,
        item,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            autoDismiss: 2,
        },
    });
}

export function* watchDeleteCargoDuplicate() {
    while (true) {
        const { item } = yield take(actionTypes.DELETE_CARGO_DUPLICATE.REQUEST);
        yield fork(deleteCargoDuplicate, item);
    }
}

export default [
    watchGetCargoDuplicates,
    watchDeleteCargoDuplicate,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/duplicates.js